const CTA_DELIMITER = '|';

const splitEncodedValue = value => {
  return typeof value === 'string'
    ? value
        .split(CTA_DELIMITER)
        .map(part => part.trim())
        .filter(part => part.length > 0)
    : [];
};

/**
 * Decode one or more CTA configs from a single Sharetribe CTA field.
 *
 * The hero section can keep using the default callToAction object from Console,
 * but if both "content" and "href" contain pipe-separated values, the field is
 * rendered as multiple buttons instead of one.
 *
 * @param {Object?} callToAction CTA field config from page asset
 * @returns {Array<Object>} decoded CTA configs
 */
export const getHeroCallToActions = callToAction => {
  if (!callToAction) {
    return [];
  }

  const { content: _content, href: _href, ...rest } = callToAction;
  const contentParts = splitEncodedValue(callToAction.content);
  const hrefParts = splitEncodedValue(callToAction.href);
  const shouldSplit = contentParts.length > 1 || hrefParts.length > 1;

  if (!shouldSplit) {
    return [callToAction];
  }

  const ctaCount = Math.max(contentParts.length, hrefParts.length);

  return Array.from({ length: ctaCount }, (_, index) => {
    const content = contentParts[index];
    const href = hrefParts[index];

    return {
      ...rest,
      ...(typeof content === 'string' ? { content } : {}),
      ...(typeof href === 'string' ? { href } : {}),
    };
  });
};
